"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.positionModifier = exports.default = exports.AnnouncementsListComponent = void 0;
var React = _interopRequireWildcard(require("react"));
var _reactWindowSize = _interopRequireDefault(require("react-window-size"));
var _List = _interopRequireDefault(require("./List.render"));
const positionModifier = exports.positionModifier = 100;
const hasAnnouncements = announcementsRequest => {
  var _announcementsRequest;
  return (announcementsRequest === null || announcementsRequest === void 0 ? void 0 : (_announcementsRequest = announcementsRequest.announcements) === null || _announcementsRequest === void 0 ? void 0 : _announcementsRequest.length) > 0;
};

/**
 * Business logic for the Announcements List component
 */
class AnnouncementsListComponent extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      maxListHeight: 0
    };
    this.handleWindowResize = this.handleWindowResize.bind(this);
    this.setAnnouncementListRef = this.setAnnouncementListRef.bind(this);
  }
  componentDidMount() {
    window.addEventListener('resize', this.handleWindowResize);
  }
  componentDidUpdate() {
    if (!this.props.isOpen) return;
    this.setMaxListHeight();
  }
  componentWillUnmount() {
    window.removeEventListener('resize', this.handleWindowResize);
  }
  setAnnouncementListRef() {
    return ref => {
      if (!ref || this.announcementsListRef) return;
      this.announcementsListRef = ref;
    };
  }
  setMaxListHeight() {
    // @ts-ignore
    const announcementsListBounds = this.announcementsListRef.getBoundingClientRect();
    const {
      windowHeight
    } = this.props;
    const maxHeight = windowHeight - positionModifier - announcementsListBounds.top;
    this.setState({
      maxListHeight: maxHeight
    });
  }
  handleWindowResize() {
    const {
      windowHeight
    } = this.props;
    if (windowHeight === this.currentWindowHeight) return;
    this.currentWindowHeight = windowHeight;
    this.setMaxListHeight();
  }
  render() {
    var _announcements$announ;
    const {
      announcements,
      isOpen
    } = this.props;
    return /*#__PURE__*/React.createElement(_List.default, {
      isOpen: isOpen,
      setAnnouncementListRef: this.setAnnouncementListRef
      // @ts-ignore
      ,
      announcements: (announcements === null || announcements === void 0 ? void 0 : (_announcements$announ = announcements.announcements) === null || _announcements$announ === void 0 ? void 0 : _announcements$announ.length) > 0 ? announcements === null || announcements === void 0 ? void 0 : announcements.announcements.slice().sort((a, b) => b.date - a.date) : null,
      maxListHeight: this.state.maxListHeight,
      hasError: announcements.hasError,
      isLoading: announcements.isLoading,
      noAnnouncements: !announcements.isLoading && !announcements.hasError && !hasAnnouncements(announcements),
      refetch: announcements.refetch
    });
  }
}

// @ts-ignore
exports.AnnouncementsListComponent = AnnouncementsListComponent;
var _default = exports.default = (0, _reactWindowSize.default)(AnnouncementsListComponent);